import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";

const UserService = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    Hourlee User Service Agreement
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
            <div className="titleSection text-center wow animate__fadeInDown">
              <h2>HOURLEE USER SERVICE AGREEMENT</h2>
            </div>
            <h2>
              <strong>1. INTRODUCTION</strong>
            </h2>
            <p>
              This <strong>Hourlee User Service Agreement</strong> (&ldquo;
              <strong>Agreement</strong>&rdquo;) governs your access to and use
              of the <strong>Hourlee Platform</strong> located at
              https://hourlee.in/ (&ldquo;<strong>Site</strong>&rdquo;),
              operated by <strong>Hourlee</strong> (&ldquo;<strong>we</strong>
              ,&rdquo; &ldquo;<strong>us</strong>,&rdquo; or &ldquo;
              <strong>our</strong>&rdquo;).
            </p>
            <p>This Agreement applies to all users of the Site, including:</p>
            <ul>
              <li>
                Individuals seeking job opportunities, gigs, or projects
                (&ldquo;<strong>Clients</strong>&rdquo;),
                <br />{" "}
              </li>
              <li>
                Individuals offering services (&ldquo;
                <strong>Service Providers</strong>&rdquo;), and
                <br />{" "}
              </li>
              <li>
                Any person accessing, browsing, or interacting with the Site in
                any way.
                <br />{" "}
              </li>
            </ul>
            <p>
              By accessing or using the Site, you acknowledge and agree that
              this Agreement governs your relationship with Hourlee in all
              matters relating to the use of the Site and the Services offered
              through it.
              <br />{" "}
            </p>
            <h2>
              <strong>2. ACCEPTANCE OF THE USER SERVICE AGREEMENT</strong>
            </h2>
            <p>
              By creating an Hourlee Account or otherwise using the Site, you
              expressly acknowledge, understand, and agree that:
            </p>
            <ol>
              <li>
                You have <strong>read and understood</strong> this Agreement.
                <br />{" "}
              </li>
              <li>
                You <strong>agree to be bound</strong> by this Agreement and all
                incorporated policies.
                <br />{" "}
              </li>
              <li>
                If you do not agree to <strong>any</strong> part of this
                Agreement, you must{" "}
                <strong>immediately stop using the Site</strong>.<br /> <br />{" "}
              </li>
            </ol>
            <p>Your continued use of Hourlee constitutes:</p>
            <ul>
              <li>
                <strong>Acceptance of this Agreement</strong>, and
                <br />{" "}
              </li>
              <li>
                <strong>
                  Consent to Hourlee&rsquo;s processing of your personal data
                </strong>
                , consistent with Hourlee&rsquo;s Privacy Policy and applicable
                Indian data protection regulations.
                <br />{" "}
              </li>
            </ul>
            <p>
              If you are using Hourlee on behalf of an entity, you represent and
              warrant that you have proper authority to bind such entity to this
              Agreement.
            </p>
            <h2>
              <strong>3. MODIFICATIONS TO THE AGREEMENT </strong>
            </h2>
            <p>
              Hourlee reserves the right, in its sole discretion, to update,
              modify, or replace any part of this Agreement at any time.
              <br />{" "}
            </p>
            <p>Any changes will be effective immediately upon:</p>
            <ul>
              <li>
                Posting the revised Agreement on{" "}
                <a href="https://hourlee.in/">
                  <strong>https://hourlee.in/</strong>
                </a>
                , and/or
                <br />{" "}
              </li>
              <li>
                Communicating updates through email or notification within your
                Hourlee Account.
                <br />{" "}
              </li>
            </ul>
            <p>
              Your continued use of the Site after changes become effective
              constitutes your acceptance of the revised Agreement.
            </p>
            <h2>
              <strong>4. USER ELIGIBILITY</strong>
            </h2>
            <p>To use Hourlee:</p>
            <ol>
              <li>
                You must be <strong>at least 18 years old</strong>.<br />{" "}
              </li>
              <li>
                You must have the <strong>legal capacity</strong> to enter into
                a binding contract under the{" "}
                <strong>Indian Contract Act, 1872</strong>.<br />{" "}
              </li>
              <li>
                You must comply with all laws, regulations, and guidelines
                applicable within the Republic of India.
                <br />{" "}
              </li>
            </ol>
            <p>
              Users under 18 are <strong>strictly prohibited</strong> from
              creating an Hourlee account or using the Site.
            </p>
            <h2>
              <strong>5. THE HOURLEE PLATFORM STRUCTURE </strong>
            </h2>
            <p>
              Hourlee operates as a <strong>technology-based platform</strong>{" "}
              that enables interactions between Clients and Service Providers
              through the following models:
            </p>
            <h3>
              <strong>
                MODEL A - Hourlee is Not a Party to Client&ndash;Service
                Provider Contracts
              </strong>
            </h3>
            <p>
              Hourlee provides a digital interface for connecting Clients with
              Service Providers.
              <br /> Contracts formed between Clients and Service Providers are{" "}
              <strong>independent</strong>, and Hourlee is{" "}
              <strong>not a party</strong> to such agreements.
              <br />{" "}
            </p>
            <p>
              <strong>MODEL B - Hourlee Marketplace Model</strong>
            </p>
            <p>
              Hourlee provides features including search, matching, project
              postings, messaging, workflow tools, and optional payment
              facilitation.
              <br /> Hourlee <strong>does not control</strong> the quality,
              legality, or delivery of services.
              <br /> The responsibility to verify skills, qualifications, and
              legitimacy rests solely with the users.
            </p>
            <h3>
              <strong>MODEL C - Hourlee Branded Offerings</strong>
            </h3>
            <p>
              In certain cases, Hourlee may provide structured or assisted
              workflows, such as:
            </p>
            <ul>
              <li>
                Pre-screened talent pools
                <br />{" "}
              </li>
              <li>
                Managed job programs
                <br />{" "}
              </li>
              <li>
                Verified Service Providers
                <br />{" "}
              </li>
              <li>
                Branded short-term or part-time workforce services
                <br />{" "}
              </li>
            </ul>
            <p>
              Even within this model, Hourlee remains a{" "}
              <strong>platform</strong> and <strong>does not employ</strong>{" "}
              Service Providers unless explicitly stated in a separate written
              agreement.
            </p>
            <p>
              Hourlee is <strong>not an employment agency</strong>,{" "}
              <strong>not a labour contractor</strong>, and{" "}
              <strong>does not guarantee employment</strong> to any user.
            </p>
            <h2>
              <strong>6. DEFINITIONS</strong>
            </h2>
            <p>
              For purposes of this Agreement, the following definitions apply :
              <br />{" "}
            </p>
            <h3>
              <strong>6.1 &ldquo;Client&rdquo;</strong>
            </h3>
            <p>
              Any user who uses Hourlee to post, request, or obtain job
              opportunities, part-time jobs, gig tasks, freelance projects, or
              other services.
            </p>
            <h3>
              <strong>6.2 &ldquo;Service Provider&rdquo;</strong>
            </h3>
            <p>
              Any user who uses Hourlee to offer or perform services, tasks,
              gigs, freelance activities, or any other form of work.
            </p>
            <h3>
              <strong>6.3 &ldquo;Site&rdquo; or &ldquo;Platform&rdquo;</strong>
            </h3>
            <p>
              The website{" "}
              <a href="https://hourlee.in/">
                <strong>https://hourlee.in/</strong>
              </a>
              , including all sub-domains, mobile interfaces, applications,
              APIs, or related Hourlee Services.
            </p>
            <h3>
              <strong>6.4 &ldquo;Hourlee Account&rdquo;</strong>
            </h3>
            <p>
              A user profile created on the Site, which includes registration
              credentials, identity information, and any data submitted by the
              user.
            </p>
            <h3>
              <strong>6.5 &ldquo;Services&rdquo;</strong>
            </h3>
            <p>
              All platform features, tools, and functionalities provided by
              Hourlee, including:
            </p>
            <ul>
              <li>
                Job or gig posting tools
                <br />{" "}
              </li>
              <li>
                Search and matching tools
                <br />{" "}
              </li>
              <li>
                Messaging
                <br />{" "}
              </li>
              <li>
                Communication tools
                <br />{" "}
              </li>
              <li>
                Platform-mediated payments
                <br />{" "}
              </li>
              <li>
                Dispute assistance
                <br />{" "}
              </li>
              <li>
                Identity verification functionalities
                <br />{" "}
              </li>
              <li>
                Any other service provided via Hourlee
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>6.6 &ldquo;Contract&rdquo;</strong>
            </h3>
            <p>
              A legally binding arrangement entered into directly between a
              Client and a Service Provider for the performance of services.
              <br /> Hourlee is <strong>not a party</strong> to these contracts.
            </p>
            <h3>
              <strong>6.7 &ldquo;User Content&rdquo;</strong>
            </h3>
            <p>
              Any information, data, documents, messages, or materials uploaded
              or transmitted by users on the Site.
            </p>
            <h2>
              <strong>
                7. RELATIONSHIP BETWEEN HOURLEE, CLIENTS, AND SERVICE PROVIDERS
              </strong>
            </h2>
            <p>
              Hourlee does <strong>not</strong>:
            </p>
            <ul>
              <li>
                Employ Service Providers
                <br />{" "}
              </li>
              <li>
                Guarantee jobs, gigs, or contracts
                <br />{" "}
              </li>
              <li>
                Supervise or control work performed by Service Providers.
                <br />{" "}
              </li>
              <li>
                Control Client selection or hiring decisions.
                <br />{" "}
              </li>
              <li>
                Provide tools, equipment, or workplace supervision.
                <br />{" "}
              </li>
              <li>
                Guarantee payments from Clients to Service Providers
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              The relationship between Clients and Service Providers is{" "}
              <strong>independent</strong>.
            </p>
            <p>
              Hourlee is a <strong>neutral digital intermediary</strong>, not an
              employer, agent, staffing firm, or representative of any party.
            </p>
            <h2>
              <strong>8. USER ACCOUNT REGISTRATION &amp; ELIGIBILITY</strong>
            </h2>
            <h3>
              <strong>8.1 Eligibility to Use Hourlee</strong>
            </h3>
            <p>
              To access or use the Hourlee Platform (&ldquo;Platform&rdquo;),
              you represent and warrant that:
              <br /> &nbsp;(a) You are at least <strong>18 years of age</strong>
              , which is the age of legal capacity in India to enter into
              binding contracts;
              <br /> &nbsp;(b) You are legally capable of entering into this
              User Service Agreement (&ldquo;Agreement&rdquo;);
              <br /> &nbsp;(c) You will comply with all applicable laws,
              including labour, tax, and data-protection legislation; and
              <br /> &nbsp;(d) You are not prohibited from using digital
              platforms under any applicable jurisdiction.
              <br />{" "}
            </p>
            <p>
              Hourlee reserves the right to deny access to any person who does
              not meet the eligibility requirements.
            </p>
            <h2>
              <strong>8.2 Account Creation Requirements</strong>
            </h2>
            <p>
              To use the Platform, you must create a user account
              (&ldquo;Account&rdquo;). During registration, you must provide
              accurate, complete, and updated information, including:
            </p>
            <ul>
              <li>
                Full Name
                <br />{" "}
              </li>
              <li>
                Email Address
                <br />{" "}
              </li>
              <li>
                Phone Number
                <br />{" "}
              </li>
              <li>
                Government-issued Identity Information (if required)
                <br />{" "}
              </li>
              <li>
                Employment or skills-related information (for job seekers)
                <br />{" "}
              </li>
              <li>
                Business details (for organizations/recruiters)
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              You agree that:
              <br /> &nbsp;(a) You will maintain accurate information at all
              times;
              <br /> &nbsp;(b) Hourlee may suspend or terminate Accounts created
              with false, incomplete, or misleading information;
              <br /> &nbsp;(c) Hourlee may request additional information to
              verify your identity.
            </p>
            <h2>
              <strong>8.3 Identity Verification Requirements</strong>
            </h2>
            <p>
              Hourlee may, at its sole discretion, require identity or
              background verification to ensure trust and platform safety. Such
              measures may include:
            </p>
            <ul>
              <li>
                Aadhaar-based KYC verification
                <br />{" "}
              </li>
              <li>
                PAN verification
                <br />{" "}
              </li>
              <li>
                Business registration verification
                <br />{" "}
              </li>
              <li>
                Phone number verification
                <br />{" "}
              </li>
              <li>
                Email verification
                <br />{" "}
              </li>
              <li>
                Employment or qualification verification
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              You acknowledge and agree that:
              <br /> &nbsp;(a) Hourlee may engage third-party verification
              service providers;
              <br /> &nbsp;(b) Hourlee makes no guarantees regarding the
              identity or legitimacy of any user;
              <br /> &nbsp;(c) You must not impersonate any other person or
              misrepresent your identity, job experience, or professional
              credentials.
            </p>
            <p>
              Verification does <strong>not</strong> create an employment
              relationship, endorsement, or guarantee of reliability.
            </p>
            <h2>
              <strong>8.4 Account Security &amp; Responsibility</strong>
            </h2>
            <p>
              You are solely responsible for:
              <br /> &nbsp;(a) maintaining the confidentiality of your login
              credentials;
              <br /> &nbsp;(b) all activities that occur under your Account;
              <br /> &nbsp;(c) notifying Hourlee immediately if you suspect
              unauthorized access.
              <br />{" "}
            </p>
            <p>
              Hourlee is not liable for any loss or damage arising from
              unauthorized Account access resulting from your failure to secure
              your credentials.
            </p>
            <p>You may not:</p>
            <ul>
              <li>
                Share your Account with any third party;
                <br />{" "}
              </li>
              <li>
                Allow others to impersonate you;
                <br />{" "}
              </li>
              <li>
                Create an Account for anyone other than yourself (unless
                registering a company profile).
                <br />{" "}
              </li>
            </ul>
            <p>
              <strong>8.5 Multiple Accounts Policy</strong>
            </p>
            <p>
              Each user may maintain only <strong>one</strong> personal Account
              and, where applicable, <strong>one</strong> business Account.
              Hourlee may suspend or remove any duplicate or suspicious Accounts
              without notice.
              <br />{" "}
            </p>
            <p>
              Using multiple Accounts to manipulate job applications, ratings,
              or platform benefits constitutes a violation of this Agreement.
            </p>
            <h2>
              <strong>8.6 Account Types on Hourlee</strong>
            </h2>
            <p>Hourlee provides two primary Account categories:</p>
            <h3>
              <strong>(a) Job Seeker Accounts</strong>
            </h3>
            <p>
              For individuals seeking employment opportunities. Such Accounts
              may include:
            </p>
            <ul>
              <li>
                Work history
                <br />{" "}
              </li>
              <li>
                Skills
                <br />{" "}
              </li>
              <li>
                Certifications
                <br />{" "}
              </li>
              <li>
                Resume/CV
                <br />{" "}
              </li>
              <li>
                Availability
                <br />{" "}
              </li>
              <li>
                Salary expectations
                <br /> <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>(b) Employer / Recruiter Accounts</strong>
            </h3>
            <p>
              For businesses, HR departments, and recruitment agencies, posting
              job opportunities. Such Accounts may require:
            </p>
            <ul>
              <li>
                Registered business name
                <br />{" "}
              </li>
              <li>
                Valid government registration details
                <br />{" "}
              </li>
              <li>
                Authorized contact person information
                <br />{" "}
              </li>
              <li>
                Compliance with applicable labour laws
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee may create additional Account types as the Platform
              evolves.
            </p>
            <h2>
              <strong>8.7 Public Profile Information</strong>
            </h2>
            <p>
              Some information may be publicly visible on your user profile,
              such as:
            </p>
            <ul>
              <li>
                Name
                <br />{" "}
              </li>
              <li>
                Skills
                <br />{" "}
              </li>
              <li>
                Employment history
                <br />{" "}
              </li>
              <li>
                Ratings or feedback (where applicable)
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              You acknowledge that information shared on your profile may be
              visible to other users and organizations.
            </p>
            <h2>
              <strong>8.8 Access to the Platform</strong>
            </h2>
            <p>
              Hourly grants you a limited, revocable, non-transferable license
              to access and use the Platform strictly in accordance with:
              <br /> &nbsp;(a) this Agreement,
              <br /> &nbsp;(b) applicable laws, and
              <br /> &nbsp;(c) instructions or guidelines published by Hourlee.
              <br />{" "}
            </p>
            <h2>
              <strong>8.9 Prohibited Uses</strong>
            </h2>
            <p>You must NOT use the Platform to:</p>
            <ul>
              <li>
                Post false or misleading job listings or resumes;
                <br />{" "}
              </li>
              <li>
                Engage in harassment, discrimination, or abusive behaviour;
                <br />{" "}
              </li>
              <li>
                Impersonate other individuals or companies;
                <br />{" "}
              </li>
              <li>
                Attempt to bypass or manipulate Platform systems;
                <br />{" "}
              </li>
              <li>
                Misuse of the personal data of other users;
                <br />{" "}
              </li>
              <li>
                Post or distribute harmful, illegal, or obscene content;
                <br />{" "}
              </li>
              <li>
                Exploit the Platform for fraudulent activity or scams;
                <br />{" "}
              </li>
              <li>
                Engage in unauthorized scraping or data extraction;
                <br />{" "}
              </li>
              <li>
                Access the Platform using bots, scripts, or automation tools;
                <br />{" "}
              </li>
              <li>
                Violate intellectual property rights of Hourlee or third
                parties;
                <br />{" "}
              </li>
              <li>
                Interfere with platform operations or security features.
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              Violation of prohibited use rules may result in Account
              termination.
            </p>
            <h2>
              <strong>8.10 Compliance With Laws</strong>
            </h2>
            <p>Users must comply with all applicable laws, including:</p>
            <ul>
              <li>
                Indian labour laws
                <br />{" "}
              </li>
              <li>
                The Information Technology Act, 2000
                <br />{" "}
              </li>
              <li>
                The Digital Personal Data Protection Act,2023 <br />{" "}
              </li>
              <li>
                Any local regulations applicable to hiring or job-seeking
                activities
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee may report unlawful activities to relevant authorities.
            </p>
            <h3>
              <strong>
                9. PLATFORM SERVICES &amp; GENERAL OPERATING TERMS
              </strong>
            </h3>
            <h2>
              <strong>9.1 Nature of the Hourlee Platform</strong>
            </h2>
            <p>
              Hourlee is an online platform that facilitates:
              <br /> &nbsp;(a) discovery of job opportunities for individuals
              (&ldquo;Job Seekers&rdquo;),
              <br /> &nbsp;(b) publication of job vacancies by employers,
              recruiters, or businesses (&ldquo;Employers&rdquo;), and
              <br /> &nbsp;(c) communication between both parties for potential
              engagement.
              <br />{" "}
            </p>
            <p>
              Hourlee is <strong>not</strong> an employer, recruitment agency,
              labour contractor, or representative of either party.
              <br /> Hourlee does <strong>not</strong> guarantee job placement,
              hiring outcomes, or suitability of candidates or employers.
            </p>
            <p>
              The Platform operates solely as a technology-driven employment
              marketplace.
            </p>
            <h2>
              <strong>9.2 Services Provided Through the Platform</strong>
            </h2>
            <p>
              Subject to this Agreement, Hourlee may provide the following
              services:
            </p>
            <ol>
              <li>
                <strong>Job Posting Services</strong> -&nbsp; allowing Employers
                to post job listings, hiring requirements, and related
                information.
                <br />{" "}
              </li>
              <li>
                <strong>Candidate Discovery</strong> - allowing Job Seekers to
                browse job opportunities relevant to their skills, location, and
                experience.
                <br />{" "}
              </li>
              <li>
                <strong>Profile Creation Tools</strong> - enabling Job Seekers
                and Employers to maintain professional profiles.
                <br />{" "}
              </li>
              <li>
                <strong>Communication Tools</strong> - enabling messaging,
                contact exchange, interview scheduling, and other interactions.
                <br />{" "}
              </li>
              <li>
                <strong>Verification Services</strong> -as determined by
                Hourlee.
                <br />{" "}
              </li>
              <li>
                <strong>Application Management Tools</strong> - tools for
                Employers to review applicants and shortlist candidates.
                <br />{" "}
              </li>
              <li>
                <strong>Notification Services</strong> - alerting users about
                job matches, applications, updates, and platform communications.
                <br /> <br />{" "}
              </li>
            </ol>
            <p>
              Hourlee may introduce additional features or discontinue any
              existing features at its sole discretion.
            </p>
            <h2>
              <strong>9.3 Job Listings &amp; Employer Responsibilities</strong>
            </h2>
            <p>Employers posting jobs on Hourlee represent and warrant that:</p>
            <p>
              (a) all job listings are{" "}
              <strong>accurate, lawful, and not misleading</strong>;<br />{" "}
              &nbsp;(b) Job requirements comply with Indian labour laws;
              <br /> &nbsp;(c) No discriminatory criteria are included unless
              legally permitted;
              <br /> &nbsp;(d) compensation, work conditions, and qualifications
              are clearly described;
              <br /> &nbsp;(e) The job posting does not advertise illegal,
              deceptive, or exploitative work;
              <br />{" "}
            </p>
            <p>Employers must not:</p>
            <ul>
              <li>
                Charge candidates unfair or illegal fees for job placement;
                <br />{" "}
              </li>
              <li>
                Post fake, duplicate, or misleading jobs;
                <br />{" "}
              </li>
              <li>
                Collect data through deceptive means;
                <br />{" "}
              </li>
              <li>
                Violate any applicable employment standards.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee retains the right to remove job posts that violate
              guidelines.
            </p>
            <h2>
              <strong>9.4 Job Seeker Obligations</strong>
            </h2>
            <p>Job Seekers agree to:</p>
            <p>
              (a) provide truthful and accurate personal, educational, and
              employment information;
              <br /> &nbsp;(b) not misrepresent work experience, identity,
              qualifications, or eligibility;
              <br /> &nbsp;(c) respect employer confidentiality and intellectual
              property;
              <br /> &nbsp;(d) comply with all interview rules and application
              processes;
              <br /> &nbsp;(e) refrain from sending abusive, threatening, or
              inappropriate messages;
              <br />{" "}
            </p>
            <p>Job Seekers must not:</p>
            <ul>
              <li>
                Apply to jobs with malicious intent.
                <br />{" "}
              </li>
              <li>
                Impersonate any other individual;
                <br />{" "}
              </li>
              <li>
                Attempt to defraud Employers.
                <br />{" "}
              </li>
              <li>
                Misuse of Employer information for non-professional purposes.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>9.5 Interactions Between Users</strong>
            </h2>
            <p>
              All interactions between Job Seekers and Employers occur{" "}
              <strong>independently</strong>. Hourlee:
              <br /> &nbsp;(a) is not a party to any employment offer or
              contract;
              <br /> &nbsp;(b) does not supervise, control, or manage either
              party;
              <br /> &nbsp;(c) is not liable for the conduct, actions, or
              omissions of any user;
              <br />{" "}
            </p>
            <p>
              Hourlee does <strong>not</strong> guarantee that:
            </p>
            <ul>
              <li>
                An Employer will select or hire a Job Seeker;
                <br />{" "}
              </li>
              <li>
                A Job Seeker will accept the offer.
                <br />{" "}
              </li>
              <li>
                Posted information is accurate or complete;
                <br />{" "}
              </li>
              <li>
                Users will behave professionally or legally.
                <br />{" "}
              </li>
            </ul>
            <p>
              Users are solely responsible for verifying the legitimacy,
              suitability, and safety of any engagement.
            </p>
            <h2>
              <strong>9.6 No Employment or Agency Relationship</strong>
            </h2>
            <p>Nothing in this Agreement creates:</p>
            <ul>
              <li>
                employer-employee relationship,
                <br />{" "}
              </li>
              <li>
                agency,
                <br />{" "}
              </li>
              <li>
                partnership,
                <br />{" "}
              </li>
              <li>
                joint venture,
                <br />{" "}
              </li>
              <li>
                recruitment agency status, or
                <br />{" "}
              </li>
              <li>
                representative authority
                <br /> Between Hourlee and any user.
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee does not negotiate employment terms or participate in
              hiring decisions.
            </p>
            <h2>
              <strong>9.7 Platform Communications &amp; Notifications</strong>
            </h2>
            <p>Hourlee may communicate with users via:</p>
            <ul>
              <li>
                email,
                <br />{" "}
              </li>
              <li>
                SMS,
                <br />{" "}
              </li>
              <li>
                push notifications,
                <br />{" "}
              </li>
              <li>
                WhatsApp or other permitted channels,
                <br />{" "}
              </li>
              <li>
                In-platform messages.
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              These communications may include:
              <br /> &nbsp;(a) job alerts,
              <br /> &nbsp;(b) account updates,
              <br /> &nbsp;(c) verification requests,
              <br /> &nbsp;(d) security notifications,
              <br /> &nbsp;(e) promotional messages.
            </p>
            <p>
              Users may manage certain marketing preferences, but cannot opt out
              of essential service communications.
            </p>
            <h2>
              <strong>9.8 Third-Party Services &amp; Integrations</strong>
            </h2>
            <p>Hourlee may integrate third-party services for:</p>
            <ul>
              <li>
                identity verification,
                <br />{" "}
              </li>
              <li>
                communication tools,
                <br />{" "}
              </li>
              <li>
                payment gateways (if applicable),
                <br />{" "}
              </li>
              <li>
                analytics,
                <br />{" "}
              </li>
              <li>
                data storage,
                <br />{" "}
              </li>
              <li>
                Security services.
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              Use of such services is governed by the respective
              providers&rsquo; terms.
              <br /> Hourlee is not responsible for third-party service
              failures, delays, or breaches.
            </p>
            <h2>
              <strong>9.9 User-Generated Content &amp; Platform Rights</strong>
            </h2>
            <p>User-generated content includes:</p>
            <ul>
              <li>
                job listings,
                <br />{" "}
              </li>
              <li>
                resumes,
                <br />{" "}
              </li>
              <li>
                profile details,
                <br />{" "}
              </li>
              <li>
                messages,
                <br />{" "}
              </li>
              <li>
                uploaded documents,
                <br />{" "}
              </li>
              <li>
                Feedback or reviews.
                <br /> <br />{" "}
              </li>
            </ul>
            <p>
              By submitting content to Hourlee, you grant Hourlee a:
              <br />{" "}
              <strong>
                Non-exclusive, worldwide, royalty-free license to use, store,
                display, reproduce, and distribute such content solely for
                Platform operation.
              </strong>
            </p>
            <p>
              You must ensure that:
              <br /> &nbsp;(a) You own or have rights to the content;
              <br /> &nbsp;(b) The content does not violate any law or infringe
              any rights.
              <br /> &nbsp;(c) content is not harmful, abusive, or fraudulent.
            </p>
            <p>Hourlee may remove content that violates this Agreement.</p>
            <h2>
              <strong>
                9.10 Accuracy and Reliability of Platform Information
              </strong>
            </h2>
            <p>Hourlee does not guarantee the accuracy of:</p>
            <ul>
              <li>
                job listings,
                <br />{" "}
              </li>
              <li>
                user profiles,
                <br />{" "}
              </li>
              <li>
                company information,
                <br />{" "}
              </li>
              <li>
                messages sent by users,
                <br />{" "}
              </li>
              <li>
                verification badges,
                <br />{" "}
              </li>
              <li>
                Algorithmic match results.
                <br />{" "}
              </li>
            </ul>
            <p>
              You acknowledge that all information is &ldquo;as-is,&rdquo; and
              Hourlee is not responsible for errors, omissions, or
              misrepresentations by users.
            </p>
            <h3>
              <strong>10. FEES, PAYMENTS, AND FINANCIAL TERMS</strong>
            </h3>
            <h2>
              <strong>10.1 General Fee Structure</strong>
            </h2>
            <p>
              Hourlee may charge certain fees to Employers, Job Seekers, or both
              for the use of specific Platform services. Such fees may include,
              but are not limited to:
              <br /> &nbsp;(a) job posting fees;
              <br /> &nbsp;(b) premium listing fees;
              <br /> &nbsp;(c) subscription plans for enhanced visibility;
              <br /> &nbsp;(d) candidate access or screening fees;
              <br /> &nbsp;(e) optional verification service fees;
              <br /> &nbsp;(f) communication tool enhancements;
              <br /> &nbsp;(g) promotional or advertising-related fees.
            </p>
            <p>
              All applicable fees will be communicated through the Platform,
              pricing pages, or during the purchase process. Users agree to
              review the fee details before making any payments.
            </p>
            <h2>
              <strong>10.2 Employer Payment Obligations</strong>
            </h2>
            <p>
              Employers agree to pay all fees associated with job postings,
              recruitment tools, premium services, or platform subscriptions
              selected through the Platform. Employers:
              <br /> &nbsp;(a) Authorize Hourlee to automatically charge their
              selected payment method;
              <br /> &nbsp;(b) are responsible for ensuring updated billing
              information;
              <br /> &nbsp;(c) Acknowledge that failure to pay may result in
              suspension or removal of job posts or account access.
            </p>
            <p>
              Hourlee is not responsible for any losses due to an
              Employer&rsquo;s failure to maintain correct billing details.
            </p>
            <h2>
              <strong>10.3 Job Seeker Payment Obligations</strong>
            </h2>
            <p>
              Hourlee may offer optional paid services for Job Seekers,
              including:
            </p>
            <ul>
              <li>
                Premium profile boosting;
                <br />{" "}
              </li>
              <li>
                featured candidate visibility;
                <br />{" "}
              </li>
              <li>
                optional background verification services;
                <br />{" "}
              </li>
              <li>
                skill test access;
                <br />{" "}
              </li>
              <li>
                Application priority placements.
                <br />{" "}
              </li>
            </ul>
            <p>
              Job Seekers acknowledge that:
              <br /> &nbsp;(a) All such paid services are optional.
              <br /> &nbsp;(b) Purchasing a paid service does{" "}
              <strong>not</strong> guarantee employment.
              <br /> &nbsp;(c) Misuse of paid services may result in account
              restrictions.
            </p>
            <h2>
              <strong>10.4 Non-Refundable Fees</strong>
            </h2>
            <p>
              Unless explicitly stated otherwise,{" "}
              <strong>
                all fees paid to Hourlee are final and non-refundable
              </strong>
              , including but not limited to:
              <br /> &nbsp;(a) job posting fees;
              <br /> &nbsp;(b) subscription fees;
              <br /> &nbsp;(c) verification fees;
              <br /> &nbsp;(d) promotional service fees;
              <br /> &nbsp;(e) candidate search fees.
            </p>
            <p>
              Refunds may only be granted where required by law or at
              Hourlee&rsquo;s sole discretion.
            </p>
            <h2>
              <strong>10.5 Subscription Services</strong>
            </h2>
            <p>
              Certain Platform functionalities may be offered on a subscription
              basis, billed monthly, quarterly, or annually. Users agree that:
              <br /> &nbsp;(a) subscriptions automatically renew unless
              canceled;
              <br /> &nbsp;(b) Renewal fees will be charged to the payment
              method on file.
              <br /> &nbsp;(c) Cancellation must occur before the next billing
              cycle to avoid auto-renewal charges.
            </p>
            <p>
              Hourlee may modify subscription pricing with prior notice, as
              permitted by applicable laws.
            </p>
            <h2>
              <strong>10.6 Invoicing and Billing</strong>
            </h2>
            <p>
              Hourlee may issue invoices electronically through email or through
              the user&rsquo;s dashboard. Users agree to:
              <br /> &nbsp;(a) review all invoices promptly;
              <br /> &nbsp;(b) raise billing disputes within{" "}
              <strong>7 days</strong> of receiving an invoice;
              <br /> &nbsp;(c) acknowledge that undisputed amounts remain
              payable.
            </p>
            <p>
              Billing disputes raised after the 7-day window may not be
              considered.
            </p>
            <h2>
              <strong>10.7 Taxes</strong>
            </h2>
            <p>
              Users are responsible for all applicable taxes, including but not
              limited to:
            </p>
            <ul>
              <li>
                GST;
                <br />{" "}
              </li>
              <li>
                service tax (if applicable);
                <br />{" "}
              </li>
              <li>
                withholding taxes;
                <br />{" "}
              </li>
              <li>
                Local duties or charges.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee may add applicable taxes to any fees charged and will
              comply with all statutory invoice and tax documentation
              obligations.
            </p>
            <h2>
              <strong>10.8 Payment Methods</strong>
            </h2>
            <p>Hourlee may support the following payment methods:</p>
            <ul>
              <li>
                Credit and debit cards;
                <br />{" "}
              </li>
              <li>
                UPI;
                <br />{" "}
              </li>
              <li>
                bank transfers;
                <br />{" "}
              </li>
              <li>
                digital wallets;
                <br />{" "}
              </li>
              <li>
                Third-party payment gateways.
                <br />{" "}
              </li>
            </ul>
            <p>
              Users authorize Hourlee and payment processors to:
              <br /> &nbsp;(a) store payment information securely;
              <br /> &nbsp;(b) initiate charges for fees, subscriptions, or
              renewals;
              <br /> &nbsp;(c) process refunds where applicable.
            </p>
            <p>Hourlee is not responsible for:</p>
            <ul>
              <li>
                Delays caused by payment processors,
                <br />{" "}
              </li>
              <li>
                failed transactions due to bank issues,
                <br />{" "}
              </li>
              <li>
                Transaction limits, reversals, or gateway errors.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>10.9 Failed or Reversed Payments</strong>
            </h2>
            <p>
              Where a payment is reversed, declined, or disputed:
              <br /> &nbsp;(a) Hourlee may suspend the user&rsquo;s access to
              paid features;
              <br /> &nbsp;(b) Any active job postings may be paused or removed;
              <br /> &nbsp;(c) Hourlee may recover outstanding amounts through
              lawful collection methods;
              <br /> &nbsp;(d) Hourlee may charge additional administrative
              fees.
            </p>
            <p>Users agree to maintain uninterrupted payment capability.</p>
            <h2>
              <strong>10.10 No Pay-to-Work Guarantee</strong>
            </h2>
            <p>
              Hourlee does <strong>not</strong> permit Employers to charge Job
              Seekers for employment opportunities unless explicitly allowed
              under applicable labour laws. Job Seekers should report any such
              abuse immediately.
            </p>
            <p>Payment for platform features does not create:</p>
            <ul>
              <li>
                A job guarantee,
                <br />{" "}
              </li>
              <li>
                a hiring guarantee,
                <br />{" "}
              </li>
              <li>
                Preferential treatment in hiring decisions.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>10.11 Adjustments and Modifications to Fees</strong>
            </h2>
            <p>
              Hourlee may modify:
              <br /> &nbsp;(a) fee structures;
              <br /> &nbsp;(b) subscription plans;
              <br /> &nbsp;(c) verification costs;
              <br /> &nbsp;(d) promotional pricing;
              <br /> &nbsp;(e) payment terms.
            </p>
            <p>
              Such modifications will apply prospectively and will be
              communicated through the Platform or email notifications.
            </p>
            <p>
              Continued use of the Platform after fee changes constitutes
              acceptance of the new terms.
            </p>
            <h2>
              <strong>10.12 Third-Party Charges</strong>
            </h2>
            <p>
              Users acknowledge that their banks, payment providers, or
              third-party services may impose transaction fees or
              currency-conversion charges, which are not controlled by Hourlee.
            </p>
            <p>Hourlee is not responsible for such charges.</p>
            <h2>
              <strong>10.13 Chargebacks and Fraudulent Claims</strong>
            </h2>
            <p>
              In case of fraudulent chargebacks or misuse of payment dispute
              mechanisms, Hourlee may:
            </p>
            <ul>
              <li>
                Suspend or terminate the user account.
                <br />{" "}
              </li>
              <li>
                Recover the disputed amount.
                <br />{" "}
              </li>
              <li>
                Report the conduct to the relevant authorities.
                <br />{" "}
              </li>
              <li>
                Restrict future access to paid features.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>
                11. USER INTERACTIONS, CONTRACTS &amp; PROFESSIONAL CONDUCT
              </strong>
            </h3>
            <h2>
              <strong>11.1 Independent Communications and Agreements</strong>
            </h2>
            <p>
              Hourlee provides a platform where Job Seekers and Employers can
              communicate.
              <br /> However,{" "}
              <strong>
                all employment-related communications occur independently
              </strong>{" "}
              between users.
            </p>
            <p>You acknowledge and agree that:</p>
            <ol>
              <li>
                Hourlee is <strong>not</strong> a party to any offer letter,
                employment contract, engagement letter, consultancy agreement,
                or any other arrangement created between Job Seekers and
                Employers.
                <br />{" "}
              </li>
              <li>
                Hourlee <strong>does not negotiate</strong>, draft, approve, or
                monitor employment terms, compensation packages, or job
                responsibilities.
                <br />{" "}
              </li>
              <li>
                Users enter into agreements{" "}
                <strong>directly with one another</strong>, at their own
                discretion and risk.
                <br />{" "}
              </li>
              <li>
                Hourlee is not responsible for enforcing or interpreting
                contractual terms between users.
                <br />{" "}
              </li>
            </ol>
            <h2>
              <strong>11.2 Interview Scheduling and Selection Process</strong>
            </h2>
            <p>Employers may invite Job Seekers for:</p>
            <ul>
              <li>
                Interviews (virtual or in-person),
                <br />{" "}
              </li>
              <li>
                screening calls,
                <br />{" "}
              </li>
              <li>
                assessments,
                <br />{" "}
              </li>
              <li>
                background checks (where lawful),
                <br />{" "}
              </li>
              <li>
                written tests,
                <br />{" "}
              </li>
              <li>
                Additional evaluations.
                <br />{" "}
              </li>
            </ul>
            <p>Hourlee is not responsible for:</p>
            <ul>
              <li>
                Interview scheduling disputes,
                <br />{" "}
              </li>
              <li>
                delays by either party,
                <br />{" "}
              </li>
              <li>
                miscommunications,
                <br />{" "}
              </li>
              <li>
                cancellations,
                <br />{" "}
              </li>
              <li>
                Any consequences arising from interviews conducted off-platform.
                <br />{" "}
              </li>
            </ul>
            <p>
              Users are solely responsible for ensuring safe, lawful, and
              professional conduct during all interactions.
            </p>
            <h2>
              <strong>11.3 Employment Offers and Acceptance</strong>
            </h2>
            <p>User responsibilities include:</p>
            <p>
              <strong>
                Employers must ensure that:
                <br />{" "}
              </strong>
              &nbsp;(a) offer letters are lawful, clear, and accurately reflect
              the job;
              <br /> &nbsp;(b) compensation, work hours, and expectations comply
              with Indian labour laws;
              <br /> &nbsp;(c) Discriminatory or unauthorized terms are not
              included.
            </p>
            <p>
              <strong>
                Job Seekers must ensure that:
                <br />{" "}
              </strong>
              &nbsp;(a) They review offer details before acceptance.
              <br /> &nbsp;(b) They do not accept multiple conflicting offers
              dishonestly.
              <br /> &nbsp;(c) They meet the eligibility and qualification
              criteria represented.
            </p>
            <p>
              Hourlee does not review, verify, or endorse any employment offers.
            </p>
            <h2>
              <strong>11.4 No Guarantee of Hiring or Job Availability</strong>
            </h2>
            <p>
              Hourlee does <strong>not</strong> guarantee:
            </p>
            <p>
              (a) that Employers will hire any Job Seeker;
              <br /> &nbsp;(b) that Job Seekers will find a suitable job;
              <br /> &nbsp;(c) the correctness or completeness of job
              availability;
              <br /> &nbsp;(d) that offers will not be withdrawn, delayed, or
              modified;
              <br /> &nbsp;(e) that the hiring process will occur within any
              specific timeline.
            </p>
            <p>
              Hourlee is a digital marketplace, not a recruiter, employer, or
              placement agency.
            </p>
            <h2>
              <strong>11.5 User Conduct and Professional Behaviour</strong>
            </h2>
            <p>
              Users agree to behave professionally and lawfully on the Platform
              and during off-platform interactions resulting from Platform
              matches.
            </p>
            <p>You must not:</p>
            <ul>
              <li>
                Harass, threaten, or abuse another user;
                <br />{" "}
              </li>
              <li>
                Make discriminatory remarks based on caste, religion, gender,
                ethnicity, disability, or any protected characteristic;
                <br />{" "}
              </li>
              <li>
                Engage in fraud, impersonation, or misrepresentation;
                <br />{" "}
              </li>
              <li>
                Solicit inappropriate content or personal favours;
                <br />{" "}
              </li>
              <li>
                Attempt to coerce, manipulate, or bribe other users;
                <br />{" "}
              </li>
              <li>
                Use profane, vulgar, or hateful language;
                <br />{" "}
              </li>
              <li>
                Communicate in a misleading or harmful manner.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee may suspend or terminate accounts violating these
              standards.
            </p>
            <h2>
              <strong>11.6 Anti-Harassment &amp; Zero-Tolerance Policy</strong>
            </h2>
            <p>Hourlee maintains a strict zero-tolerance policy for:</p>
            <ul>
              <li>
                sexual harassment,
                <br />{" "}
              </li>
              <li>
                bullying,
                <br />{" "}
              </li>
              <li>
                stalking,
                <br />{" "}
              </li>
              <li>
                unwanted advances,
                <br />{" "}
              </li>
              <li>
                degrading or abusive behaviour,
                <br />{" "}
              </li>
              <li>
                discriminatory conduct,
                <br />{" "}
              </li>
              <li>
                Sharing of explicit or violent content.
                <br />{" "}
              </li>
            </ul>
            <p>
              Any user engaging in such conduct may be removed from the Platform{" "}
              <strong>immediately</strong>.
            </p>
            <p>
              Hourlee may also cooperate with law enforcement where appropriate.
            </p>
            <h2>
              <strong>11.7 No Circumvention of Platform Rules</strong>
            </h2>
            <p>Users agree NOT to:</p>
            <p>
              (a) bypass Hourlee systems in ways that attempt to avoid fees,
              platform processes, or safety checks;
              <br /> &nbsp;(b) misrepresent Platform interactions;
              <br /> &nbsp;(c) manipulate algorithms or search results;
              <br /> &nbsp;(d) exchange misleading job information or fabricated
              credentials.
            </p>
            <p>
              Hourlee may impose penalties or suspend accounts engaging in
              circumvention.
            </p>
            <h2>
              <strong>
                11.8 Background Checks and Verification Outside Hourlee
              </strong>
            </h2>
            <p>If Employers conduct off-platform verification, such as:</p>
            <ul>
              <li>
                Criminal record checks,
                <br />{" "}
              </li>
              <li>
                address verifications,
                <br />{" "}
              </li>
              <li>
                employment history checks,
                <br />{" "}
              </li>
              <li>
                reference checks,
                <br />{" "}
              </li>
              <li>
                medical fitness tests,
                <br />{" "}
              </li>
            </ul>
            <p>Then:</p>
            <ul>
              <li>
                Hourlee is <strong>not involved</strong> in these processes,
                <br />{" "}
              </li>
              <li>
                Hourlee does <strong>not guarantee accuracy</strong>,<br />{" "}
              </li>
              <li>
                Hourlee is <strong>not responsible</strong> for the outcome,
                delays, or disputes,
                <br />{" "}
              </li>
              <li>
                Job Seekers and Employers are responsible for ensuring
                compliance with applicable laws.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>11.9 Safety Precautions for In-Person Meetings</strong>
            </h2>
            <p>If Job Seekers or Employers decide to meet physically:</p>
            <ul>
              <li>
                Meetings are arranged{" "}
                <strong>solely at the discretion of both parties</strong>.<br />{" "}
              </li>
              <li>
                Hourlee does <strong>not</strong> arrange or monitor meetings.
                <br />{" "}
              </li>
              <li>
                Hourlee does <strong>not</strong> guarantee the safety or
                legitimacy of any meeting.
                <br />{" "}
              </li>
              <li>
                Users must take precautions such as meeting in public spaces and
                informing trusted contacts.
                <br />{" "}
              </li>
            </ul>
            <p>
              Any harm, injury, loss, or dispute resulting from in-person
              meetings is strictly between the parties.
            </p>
            <h2>
              <strong>
                11.10 User Responsibility for Accuracy and Legitimacy
              </strong>
            </h2>
            <p>
              Job Seekers and Employers are individually responsible for
              ensuring:
            </p>
            <ul>
              <li>
                Accuracy of job descriptions and resumes;
                <br />{" "}
              </li>
              <li>
                truthfulness of claims;
                <br />{" "}
              </li>
              <li>
                lawful behaviour;
                <br />{" "}
              </li>
              <li>
                verification of information shared by the other party;
                <br />{" "}
              </li>
              <li>
                ensuring contractual commitments are honoured;
                <br />{" "}
              </li>
              <li>
                Reporting suspicious behaviour promptly.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee is not liable for false statements or fraudulent profiles
              created by users.
            </p>
            <h2>
              <strong>11.11 Allocation of Risk</strong>
            </h2>
            <p>You acknowledge and agree that:</p>
            <ol>
              <li>
                All risks associated with interactions, hiring decisions, and
                negotiations are borne by the users.
                <br />{" "}
              </li>
              <li>
                Hourlee is not liable for:
                <br />{" "}
              </li>
            </ol>
            <ul>
              <li>
                loss of employment opportunity;
                <br />{" "}
              </li>
              <li>
                rejection or withdrawal of job offers;
                <br />{" "}
              </li>
              <li>
                inaccurate candidate or employer information;
                <br />{" "}
              </li>
              <li>
                any financial or reputational harm;
                <br />{" "}
              </li>
              <li>
                Any unsafe or unlawful conduct of users.
                <br />{" "}
              </li>
            </ul>
            <ol>
              <li>
                Users must independently evaluate the suitability of any
                proposed job or candidate.
                <br />{" "}
              </li>
            </ol>
            <h2>
              <strong>11.12 Reporting Violations</strong>
            </h2>
            <p>
              Users may report violations, abusive conduct, fraud, or suspicious
              behaviour through:
            </p>
            <ul>
              <li>
                In-platform reporting tools,
                <br />{" "}
              </li>
              <li>
                Hourlee support email,
                <br />{" "}
              </li>
              <li>
                Grievance redressal channels.
                <br />{" "}
              </li>
            </ul>
            <p>Hourlee may take appropriate actions, including:</p>
            <ul>
              <li>
                warnings,
                <br />{" "}
              </li>
              <li>
                profile edits or removals,
                <br />{" "}
              </li>
              <li>
                account suspensions,
                <br />{" "}
              </li>
              <li>
                permanent bans,
                <br />{" "}
              </li>
              <li>
                Legal escalations were required.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee is not obligated to disclose internal investigative
              outcomes.
            </p>
            <h3>
              <strong>
                12. INTELLECTUAL PROPERTY RIGHTS &amp; PLATFORM OWNERSHIP
              </strong>
            </h3>
            <h2>
              <strong>12.1 Ownership of the Hourlee Platform</strong>
            </h2>
            <p>
              The Hourlee Platform, located at{" "}
              <a href="https://hourlee.in/">
                <strong>https://hourlee.in/</strong>
              </a>
              , includes all:
            </p>
            <ul>
              <li>
                text,
                <br />{" "}
              </li>
              <li>
                images,
                <br />{" "}
              </li>
              <li>
                software,
                <br />{" "}
              </li>
              <li>
                code,
                <br />{" "}
              </li>
              <li>
                graphics,
                <br />{" "}
              </li>
              <li>
                logos,
                <br />{" "}
              </li>
              <li>
                layouts,
                <br />{" "}
              </li>
              <li>
                algorithms,
                <br />{" "}
              </li>
              <li>
                databases,
                <br />{" "}
              </li>
              <li>
                user interface elements,
                <br />{" "}
              </li>
              <li>
                design structures,
                <br />{" "}
              </li>
              <li>
                templates,
                <br />{" "}
              </li>
              <li>
                scripts,
                <br />{" "}
              </li>
              <li>
                API functionalities,
                <br />{" "}
              </li>
              <li>
                proprietary tools
                <br />{" "}
              </li>
            </ul>
            <p>
              Is the exclusive property of <strong>Hourlee</strong> and its
              licensors.
            </p>
            <p>
              You acknowledge that the Platform is protected under Indian and
              international law:
            </p>
            <ul>
              <li>
                copyright laws,
                <br />{" "}
              </li>
              <li>
                trademark laws,
                <br />{" "}
              </li>
              <li>
                patent laws,
                <br />{" "}
              </li>
              <li>
                Trade secret laws,
                <br />{" "}
              </li>
              <li>
                database rights, and
                <br />{" "}
              </li>
              <li>
                Other intellectual property regulations.
                <br />{" "}
              </li>
            </ul>
            <p>
              No intellectual property rights are transferred to you under this
              Agreement.
            </p>
            <h2>
              <strong>12.2 License to Use the Platform</strong>
            </h2>
            <p>
              Hourlee grants users a limited, non-exclusive, non-transferable,
              revocable license to access and use the Platform{" "}
              <strong>
                solely for lawful job-seeking or recruitment purposes
              </strong>
              .
            </p>
            <p>
              This license does <strong>not</strong> permit users to:
              <br /> &nbsp;(a) copy, reproduce, or mirror the Platform;
              <br /> &nbsp;(b) distribute or sublicense Platform elements;
              <br /> &nbsp;(c) reverse engineer or attempt to extract source
              code;
              <br /> &nbsp;(d) modify, alter, or create derivative works;
              <br /> &nbsp;(e) attempt to access restricted areas of the
              Platform;
              <br /> &nbsp;(f) use automated means (bots, crawlers, scrapers)
              without explicit permission.
            </p>
            <p>Any use beyond the limited license constitutes infringement.</p>
            <h2>
              <strong>12.3 Restrictions on Use of the Platform</strong>
            </h2>
            <p>
              Users must <strong>not</strong>, directly or indirectly:
            </p>
            <ol>
              <li>
                <strong>
                  Scrape Data
                  <br />{" "}
                </strong>
                &nbsp;Use bots, spiders, or automated software to copy or
                harvest data from Hourlee.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Modify the Platform
                  <br />{" "}
                </strong>
                &nbsp;Alter, interfere with, or tamper with Platform code,
                security systems, or digital architecture.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Reverse Engineering
                  <br />{" "}
                </strong>
                &nbsp;Attempt to analyze or derive the Platform&rsquo;s source
                code, algorithms, database functions, or backend systems.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Frame or Reproduce the Platform
                  <br />{" "}
                </strong>
                &nbsp;Embed Hourlee pages into other websites or applications
                without authorization.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Copy User Interface or Design Elements
                  <br />{" "}
                </strong>
                &nbsp;Replicate layouts, structures, visual elements, or
                branding materials.
                <br />{" "}
              </li>
              <li>
                <strong>
                  Use Platform Content for Commercial Exploitation
                  <br />{" "}
                </strong>
                &nbsp;Without written consent from Hourlee.
                <br />{" "}
              </li>
            </ol>
            <p>
              Violation of these restrictions may result in immediate legal
              action.
            </p>
            <h3>
              <strong>
                13. USER CONTENT OWNERSHIP &amp; LICENSE TO HOURLEE
              </strong>
            </h3>
            <h2>
              <strong>13.1 Ownership of User Content</strong>
            </h2>
            <p>
              Users retain ownership of all content they upload to Hourlee,
              including:
            </p>
            <ul>
              <li>
                resumes,
                <br />{" "}
              </li>
              <li>
                job listings,
                <br />{" "}
              </li>
              <li>
                skills information,
                <br />{" "}
              </li>
              <li>
                company profiles,
                <br />{" "}
              </li>
              <li>
                photos,
                <br />{" "}
              </li>
              <li>
                certifications,
                <br />{" "}
              </li>
              <li>
                descriptions,
                <br />{" "}
              </li>
              <li>
                messages,
                <br />{" "}
              </li>
              <li>
                Ratings or feedback.
                <br />{" "}
              </li>
            </ul>
            <p>Hourlee does not claim ownership over such content.</p>
            <p>
              However, by uploading content, you grant Hourlee certain usage
              rights as described below.
            </p>
            <h2>
              <strong>13.2 License Granted to Hourlee</strong>
            </h2>
            <p>By submitting content on Hourlee, you grant Hourlee a:</p>
            <p>
              <strong>
                worldwide, royalty-free, non-exclusive, transferable,
                sublicensable license
                <br />{" "}
              </strong>
              &nbsp;To:
            </p>
            <ul>
              <li>
                use,
                <br />{" "}
              </li>
              <li>
                store,
                <br />{" "}
              </li>
              <li>
                reproduce,
                <br />{" "}
              </li>
              <li>
                distribute,
                <br />{" "}
              </li>
              <li>
                display,
                <br />{" "}
              </li>
              <li>
                Modify (only for formatting or platform compatibility),
                <br />{" "}
              </li>
              <li>
                host,
                <br />{" "}
              </li>
              <li>
                publish
                <br />{" "}
              </li>
            </ul>
            <p>
              Your content is{" "}
              <strong>
                for the purpose of operating, improving, and promoting the
                Platform.
              </strong>
            </p>
            <p>This license is required to enable:</p>
            <ul>
              <li>
                Displaying resumes to Employers,
                <br />{" "}
              </li>
              <li>
                showing job listings to Job Seekers,
                <br />{" "}
              </li>
              <li>
                hosting public profile data,
                <br />{" "}
              </li>
              <li>
                processing search results,
                <br />{" "}
              </li>
              <li>
                Enabling platform communication tools.
                <br />{" "}
              </li>
            </ul>
            <p>This license automatically terminates when:</p>
            <ul>
              <li>
                You delete your content, or
                <br />{" "}
              </li>
              <li>
                Your account is terminated.
                <br />{" "}
              </li>
            </ul>
            <p>
              Except where Hourlee must retain data for legitimate legal,
              security, archival, or compliance purposes.
            </p>
            <h2>
              <strong>13.3 Representations About User Content</strong>
            </h2>
            <p>You represent and warrant that:</p>
            <p>
              (a) You own or have the legal right to upload the content;
              <br /> &nbsp;(b) the content does not infringe any copyright,
              trademark, trade secret, privacy right, or contract;
              <br /> &nbsp;(c) The content is accurate and lawful.
              <br /> &nbsp;(d) The content does not contain viruses, malicious
              code, or harmful elements;
              <br /> &nbsp;(e) Hourlee&rsquo;s use of the content does not
              violate the rights of any third party.
            </p>
            <p>
              Users are solely responsible for the consequences arising from
              their posted content.
            </p>
            <h3>
              <strong>14. TRADEMARKS &amp; BRAND PROTECTIONS</strong>
            </h3>
            <h2>
              <strong>14.1 Hourlee Trademarks</strong>
            </h2>
            <p>
              The following are trademarks or registered trademarks owned
              exclusively by Hourlee:
            </p>
            <ul>
              <li>
                &ldquo;Hourlee&rdquo;
                <br />{" "}
              </li>
              <li>
                Hourlee logos
                <br />{" "}
              </li>
              <li>
                Hourlee slogan(s)
                <br />{" "}
              </li>
              <li>
                Any Hourlee service marks or brand identifiers
                <br />{" "}
              </li>
            </ul>
            <p>
              You agree not to use Hourlee&rsquo;s trademarks in a way that may
              cause confusion, misrepresentation, or false affiliation.
            </p>
            <p>Prohibited uses include:</p>
            <ul>
              <li>
                Claiming association with Hourlee without permission;
                <br />{" "}
              </li>
              <li>
                copying logos or branding elements;
                <br />{" "}
              </li>
              <li>
                Using marks in domain names, advertisements, metatags, or
                promotional materials.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>14.2 Prohibition Against Misuse</strong>
            </h2>
            <p>You must not:</p>
            <p>
              (a) falsely represent yourself as an Hourlee employee, partner, or
              agent;
              <br /> &nbsp;(b) Use Hourlee brand elements for commercial
              marketing.
              <br /> &nbsp;(c) engage in behaviour that harms Hourlee&rsquo;s
              reputation;
              <br /> &nbsp;(d) use the Platform&rsquo;s look and feel to create
              a competing service;
              <br /> &nbsp;(e) alter or obscure Hourlee trademarks in any
              manner.
            </p>
            <h3>
              <strong>15. SOFTWARE &amp; TECHNOLOGY TERMS</strong>
            </h3>
            <h2>
              <strong>15.1 Platform Software</strong>
            </h2>
            <p>
              Hourlee may require downloading or using software components such
              as:
            </p>
            <ul>
              <li>
                mobile applications,
                <br />{" "}
              </li>
              <li>
                web-based scripts,
                <br />{" "}
              </li>
              <li>
                APIs,
                <br />{" "}
              </li>
              <li>
                verification modules,
                <br />{" "}
              </li>
              <li>
                Communication extensions.
                <br />{" "}
              </li>
            </ul>
            <p>These components may receive automatic updates or patches.</p>
            <p>
              Tampering with or disabling these components is strictly
              prohibited.
            </p>
            <h2>
              <strong>15.2 APIs and Integrations</strong>
            </h2>
            <p>Users must not:</p>
            <p>
              (a) integrate external software into Hourlee without explicit
              permission;
              <br /> &nbsp;(b) misuse or overload API endpoints;
              <br /> &nbsp;(c) circumvent platform-access limits;
              <br /> &nbsp;(d) Extract mass data through integrations.
            </p>
            <p>Hourlee may suspend access for abuse or misuse of APIs.</p>
            <h2>
              <strong>15.3 Security Protections</strong>
            </h2>
            <p>Users must not:</p>
            <ul>
              <li>
                Bypass access controls;
                <br />{" "}
              </li>
              <li>
                Probe or scan network systems;
                <br />{" "}
              </li>
              <li>
                Perform penetration testing without authorization.
                <br />{" "}
              </li>
              <li>
                exploit vulnerabilities;
                <br />{" "}
              </li>
              <li>
                Introduce harmful scripts, files, or malware.
                <br />{" "}
              </li>
            </ul>
            <p>Unauthorized access or security violations may result in:</p>
            <ul>
              <li>
                account termination,
                <br />{" "}
              </li>
              <li>
                civil liability,
                <br />{" "}
              </li>
              <li>
                Criminal prosecution under the Information Technology Act, 2000.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>16. DATA PROTECTION &amp; PRIVACY OBLIGATIONS</strong>
            </h3>
            <h2>
              <strong>16.1 Commitment to Data Protection</strong>
            </h2>
            <p>
              Hourlee is committed to maintaining the confidentiality,
              integrity, and security of all user data. Hourlee processes
              personal information in accordance with:
            </p>
            <ul>
              <li>
                Indian data protection laws, including the Information
                Technology Act, 2000;
                <br />{" "}
              </li>
              <li>
                The Digital Personal Data Protection Act (DPDPA), 2023 ;<br />{" "}
              </li>
              <li>
                applicable privacy and security regulations;
                <br />{" "}
              </li>
              <li>
                Platform-specific internal policies.
                <br />{" "}
              </li>
            </ul>
            <p>
              By using the Platform, you consent to the collection, storage, and
              processing of your information as described in the Hourlee Privacy
              Notice.
            </p>
            <h2>
              <strong>16.2 Categories of User Data Collected</strong>
            </h2>
            <p>
              Hourlee may collect, store, and process the following categories
              of personal and professional data:
            </p>
            <h3>
              <strong>(a) Job Seeker Data</strong>
            </h3>
            <ul>
              <li>
                Name, age, contact details
                <br />{" "}
              </li>
              <li>
                Resume/CV, skills, qualifications
                <br />{" "}
              </li>
              <li>
                Work history and references
                <br />{" "}
              </li>
              <li>
                Identity documents (if verification services are used)
                <br />{" "}
              </li>
              <li>
                Profile photos
                <br />{" "}
              </li>
              <li>
                Communication Records with Employers
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>(b) Employer Data</strong>
            </h3>
            <ul>
              <li>
                Company name, contact details
                <br />{" "}
              </li>
              <li>
                Authorized representative details
                <br />{" "}
              </li>
              <li>
                Job descriptions and requirements
                <br />{" "}
              </li>
              <li>
                Business registration documents
                <br />{" "}
              </li>
              <li>
                Communication with Job Seekers
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>(c) Platform Interaction Data</strong>
            </h3>
            <ul>
              <li>
                Login information
                <br />{" "}
              </li>
              <li>
                Device and browser metadata
                <br />{" "}
              </li>
              <li>
                Activity logs
                <br />{" "}
              </li>
              <li>
                User search preferences
                <br />{" "}
              </li>
              <li>
                Application activity
                <br />{" "}
              </li>
              <li>
                Communication metadata
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee may update its data collection practices as the Platform
              evolves.
            </p>
            <h2>
              <strong>16.3 Purpose of Processing Personal Data</strong>
            </h2>
            <p>
              Hourlee processes data for legitimate and lawful purposes,
              including:
            </p>
            <ol>
              <li>
                Operating the job marketplace;
                <br />{" "}
              </li>
              <li>
                facilitating interactions between Job Seekers and Employers;
                <br />{" "}
              </li>
              <li>
                identity verification and safety;
                <br />{" "}
              </li>
              <li>
                enhancing user experience;
                <br />{" "}
              </li>
              <li>
                troubleshooting, analytics, and product improvement;
                <br />{" "}
              </li>
              <li>
                compliance with legal obligations;
                <br />{" "}
              </li>
              <li>
                prevention of fraud, abuse, and misuse;
                <br />{" "}
              </li>
              <li>
                Communication regarding platform updates and notifications.
                <br />{" "}
              </li>
            </ol>
            <p>
              Users agree that Hourlee may process data for any purpose
              consistent with these objectives.
            </p>
            <h2>
              <strong>16.4 Legal Basis for Processing</strong>
            </h2>
            <p>Hourlee processes data on the basis of:</p>
            <ul>
              <li>
                <strong>User consent</strong> is provided when creating an
                account.
                <br />{" "}
              </li>
              <li>
                <strong>contractual necessity</strong> to provide Platform
                services;
                <br />{" "}
              </li>
              <li>
                <strong>legitimate interests</strong> in maintaining platform
                integrity and improving operations;
                <br />{" "}
              </li>
              <li>
                <strong>compliance with Indian legal obligations</strong>;<br />{" "}
              </li>
              <li>
                <strong>Prevention and detection of fraud</strong>, misuse, or
                unlawful conduct.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>16.5 Data Sharing With Third Parties</strong>
            </h2>
            <p>Hourlee may share user data with:</p>
            <ul>
              <li>
                verification vendors;
                <br />{" "}
              </li>
              <li>
                payment processors (if applicable);
                <br />{" "}
              </li>
              <li>
                cloud service providers;
                <br />{" "}
              </li>
              <li>
                communication tool providers;
                <br />{" "}
              </li>
              <li>
                analytics partners;
                <br />{" "}
              </li>
              <li>
                law enforcement agencies (where required by law);
                <br />{" "}
              </li>
              <li>
                Business support partners.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee ensures that all third-party processors maintain adequate
              data protection standards.
            </p>
            <p>
              Hourlee does <strong>not</strong> sell user data to third parties.
            </p>
            <h2>
              <strong>16.6 Cross-Border Data Transfers</strong>
            </h2>
            <p>
              Where necessary, Hourlee may transfer user data to servers or
              service providers located outside India.
              <br /> &nbsp;Such transfers will be conducted:
            </p>
            <ul>
              <li>
                lawfully,
                <br />{" "}
              </li>
              <li>
                securely,
                <br />{" "}
              </li>
              <li>
                with contractual safeguards,
                <br />{" "}
              </li>
              <li>
                And strictly for operational purposes.
                <br />{" "}
              </li>
            </ul>
            <p>Users consent to such transfers when using the Platform.</p>
            <h3>
              <strong>17. CONFIDENTIALITY OBLIGATIONS</strong>
            </h3>
            <h2>
              <strong>17.1 Confidential Information</strong>
            </h2>
            <p>
              &ldquo;Confidential Information&rdquo; includes all non-public
              information shared between users or provided on the Platform,
              including but not limited to:
            </p>
            <ul>
              <li>
                resumes,
                <br />{" "}
              </li>
              <li>
                interview responses,
                <br />{" "}
              </li>
              <li>
                job descriptions,
                <br />{" "}
              </li>
              <li>
                company strategies,
                <br />{" "}
              </li>
              <li>
                proprietary data,
                <br />{" "}
              </li>
              <li>
                trade secrets,
                <br />{" "}
              </li>
              <li>
                employee or HR data,
                <br />{" "}
              </li>
              <li>
                contact details,
                <br />{" "}
              </li>
              <li>
                Communication transcripts.
                <br />{" "}
              </li>
            </ul>
            <p>
              Users must treat such information as confidential and must not
              disclose it to third parties except as required to complete
              legitimate hiring or job-seeking activities.
            </p>
            <h2>
              <strong>17.2 User Confidentiality Responsibilities</strong>
            </h2>
            <p>Users agree to:</p>
            <ol>
              <li>
                Protect confidential information with reasonable safeguards.
                <br />{" "}
              </li>
              <li>
                Use such information solely for hiring or job application
                purposes;
                <br />{" "}
              </li>
              <li>
                Refrain from posting or sharing confidential information
                publicly.
                <br />{" "}
              </li>
              <li>
                Not duplicate or misuse documents submitted by other users;
                <br />{" "}
              </li>
              <li>
                Promptly delete confidential information if an application or
                interaction ends.
                <br />{" "}
              </li>
            </ol>
            <h2>
              <strong>17.3 Hourlee Confidential Information</strong>
            </h2>
            <p>
              The following is considered Hourlee&rsquo;s confidential
              information:
            </p>
            <ul>
              <li>
                platform code,
                <br />{" "}
              </li>
              <li>
                system architecture,
                <br />{" "}
              </li>
              <li>
                security mechanisms,
                <br />{" "}
              </li>
              <li>
                internal processes,
                <br />{" "}
              </li>
              <li>
                proprietary algorithms,
                <br />{" "}
              </li>
              <li>
                backend tools,
                <br />{" "}
              </li>
              <li>
                Non-public documentation.
                <br />{" "}
              </li>
            </ul>
            <p>Users must not disclose or misuse such information.</p>
            <h3>
              <strong>18. DATA RIGHTS OF USERS</strong>
            </h3>
            <p>Job Seekers and Employers have the right to:</p>
            <ol>
              <li>
                <strong>Access</strong> their personal data processed on the
                Platform;
                <br />{" "}
              </li>
              <li>
                <strong>Correct</strong> inaccurate or outdated data;
                <br />{" "}
              </li>
              <li>
                <strong>Request deletion</strong> of their data (subject to
                legal limits);
                <br />{" "}
              </li>
              <li>
                <strong>Withdraw consent</strong> where processing is based on
                consent;
                <br />{" "}
              </li>
              <li>
                <strong>Request a copy</strong> of certain data (where
                applicable);
                <br />{" "}
              </li>
              <li>
                <strong>Disable marketing communications</strong>;<br />{" "}
              </li>
              <li>
                <strong>Request account closure</strong>.<br />{" "}
              </li>
            </ol>
            <p>Hourlee may retain data as required by:</p>
            <ul>
              <li>
                law,
                <br />{" "}
              </li>
              <li>
                security obligations,
                <br />{" "}
              </li>
              <li>
                fraud prevention,
                <br />{" "}
              </li>
              <li>
                dispute resolution,
                <br />{" "}
              </li>
              <li>
                Platform integrity.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>19. DATA RETENTION</strong>
            </h3>
            <p>Hourlee retains personal data only for as long as:</p>
            <ul>
              <li>
                Necessary for legitimate business purposes;
                <br />{" "}
              </li>
              <li>
                required by Indian laws;
                <br />{" "}
              </li>
              <li>
                needed to enforce this Agreement;
                <br />{" "}
              </li>
              <li>
                required to address fraud, security, or abuse;
                <br />{" "}
              </li>
              <li>
                Necessary for resolving disputes.
                <br />{" "}
              </li>
            </ul>
            <p>Upon account closure, Hourlee will:</p>
            <ul>
              <li>
                Deactivate user access, and
                <br />{" "}
              </li>
              <li>
                Retain data only for legally permitted retention periods.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>20. SECURITY MEASURES</strong>
            </h3>
            <p>
              Hourlee uses appropriate technical and organizational measures,
              including:
            </p>
            <ul>
              <li>
                encryption,
                <br />{" "}
              </li>
              <li>
                secure access controls,
                <br />{" "}
              </li>
              <li>
                firewalls,
                <br />{" "}
              </li>
              <li>
                threat detection systems,
                <br />{" "}
              </li>
              <li>
                audit logs,
                <br />{" "}
              </li>
              <li>
                restricted access policies,
                <br />{" "}
              </li>
              <li>
                Routine vulnerability assessments.
                <br />{" "}
              </li>
            </ul>
            <p>
              However, users acknowledge that{" "}
              <strong>no system is 100% secure</strong>, and Hourlee cannot
              guarantee absolute protection against cyberattacks or data
              breaches.
            </p>
            <p>Users must also maintain secure practices, including:</p>
            <ul>
              <li>
                strong passwords,
                <br />{" "}
              </li>
              <li>
                careful sharing of personal data,
                <br />{" "}
              </li>
              <li>
                Vigilance against phishing attempts.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>21. REPORTING SECURITY OR PRIVACY ISSUES</strong>
            </h3>
            <p>Users may report:</p>
            <ul>
              <li>
                suspicious activity,
                <br />{" "}
              </li>
              <li>
                security vulnerabilities,
                <br />{" "}
              </li>
              <li>
                unauthorized access attempts,
                <br />{" "}
              </li>
              <li>
                privacy concerns
                <br />{" "}
              </li>
            </ul>
            <p>
              Through Hourlee&rsquo;s designated support or grievance channels.
            </p>
            <p>Hourlee may take actions, including:</p>
            <ul>
              <li>
                internal investigation,
                <br />{" "}
              </li>
              <li>
                suspension of accounts,
                <br />{" "}
              </li>
              <li>
                legal escalation,
                <br />{" "}
              </li>
              <li>Mandatory reporting to authorities (if required).</li>
            </ul>
            <h3>
              <strong>22. GENERAL DISCLAIMERS</strong>
            </h3>
            <h2>
              <strong>22.1 Platform Provided &ldquo;As-Is&rdquo;</strong>
            </h2>
            <p>
              The Hourlee Platform, including all tools, services, features, and
              information, is provided strictly on an{" "}
              <strong>
                &ldquo;as-is&rdquo; and &ldquo;as-available&rdquo;
              </strong>{" "}
              basis.
            </p>
            <p>
              Hourlee does <strong>not</strong> guarantee that:
            </p>
            <ul>
              <li>
                The Platform will function without interruption, delays, or
                errors;
                <br />{" "}
              </li>
              <li>
                All features will be available at all times.
                <br />{" "}
              </li>
              <li>
                Job listings or resumes are accurate, lawful, or complete;
                <br />{" "}
              </li>
              <li>
                Users will behave professionally or lawfully;
                <br />{" "}
              </li>
              <li>
                Hiring outcomes or job matches will meet expectations.
                <br />{" "}
              </li>
              <li>
                The Platform will always be secure, free of malware, and
                compatible with all devices.
                <br />{" "}
              </li>
            </ul>
            <p>
              You agree that use of the Platform is at your{" "}
              <strong>sole risk</strong>.
            </p>
            <h2>
              <strong>
                22.2 No Recruitment, Staffing, or Employment Agency Role
              </strong>
            </h2>
            <p>
              Hourlee is <strong>not</strong>:
            </p>
            <ul>
              <li>
                an employer,
                <br />{" "}
              </li>
              <li>
                a staffing firm,
                <br />{" "}
              </li>
              <li>
                a labour contractor,
                <br />{" "}
              </li>
              <li>
                a job placement agency,
                <br />{" "}
              </li>
              <li>
                an HR services provider,
                <br />{" "}
              </li>
              <li>
                A representative of any user.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee <strong>does not</strong>:
            </p>
            <ul>
              <li>
                Participate in negotiations;
                <br />{" "}
              </li>
              <li>
                Verify employment terms.
                <br />{" "}
              </li>
              <li>
                Endorse any employer or candidate;
                <br />{" "}
              </li>
              <li>
                Guarantee that a job seeker is qualified;
                <br />{" "}
              </li>
              <li>
                Guarantee that an employer is trustworthy;
                <br />{" "}
              </li>
              <li>
                Monitor or supervise work arrangements.
                <br />{" "}
              </li>
            </ul>
            <p>
              All employment decisions occur <strong>independently</strong>{" "}
              between users.
            </p>
            <h2>
              <strong>22.3 No Guarantee of Job Opportunities or Hiring</strong>
            </h2>
            <p>You acknowledge that Hourlee:</p>
            <ul>
              <li>
                Does <strong>not guarantee</strong> job placement;
                <br />{" "}
              </li>
              <li>
                does <strong>not guarantee</strong> interview selection;
                <br />{" "}
              </li>
              <li>
                does <strong>not guarantee</strong> response times from
                employers;
                <br />{" "}
              </li>
              <li>
                Does <strong>not guarantee</strong> that job postings are
                legitimate, available, or updated.
                <br />{" "}
              </li>
            </ul>
            <p>
              Job availability is subject to market conditions and employer
              discretion.
            </p>
            <h2>
              <strong>22.4 User-Provided Content Disclaimer</strong>
            </h2>
            <p>
              Hourlee does <strong>not</strong> control or verify:
            </p>
            <ul>
              <li>
                resumes,
                <br />{" "}
              </li>
              <li>
                job descriptions,
                <br />{" "}
              </li>
              <li>
                compensation details,
                <br />{" "}
              </li>
              <li>
                identity declarations,
                <br />{" "}
              </li>
              <li>
                employer information,
                <br />{" "}
              </li>
              <li>
                professional qualifications,
                <br />{" "}
              </li>
              <li>
                uploaded documents,
                <br />{" "}
              </li>
              <li>
                Communication between users.
                <br />{" "}
              </li>
            </ul>
            <p>
              Users are solely responsible for the accuracy and legality of
              their content.
            </p>
            <h2>
              <strong>22.5 Third-Party Services Disclaimer</strong>
            </h2>
            <p>The Platform may rely on third-party:</p>
            <ul>
              <li>
                cloud providers,
                <br />{" "}
              </li>
              <li>
                verification agencies,
                <br />{" "}
              </li>
              <li>
                payment gateways,
                <br />{" "}
              </li>
              <li>
                analytics tools,
                <br />{" "}
              </li>
              <li>
                Communication services.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee is <strong>not responsible</strong> for failures, errors,
              or delays caused by third-party services.
            </p>
            <h3>
              <strong>23. LIMITATION OF LIABILITY</strong>
            </h3>
            <h2>
              <strong>23.1 Maximum Liability</strong>
            </h2>
            <p>To the extent permitted under applicable law:</p>
            <h3>
              <strong>
                Hourlee&rsquo;s total cumulative liability to any user, for any
                claim arising out of or related to the Platform, shall not
                exceed the total amount paid by the user to Hourlee in the
                previous 12 months.
              </strong>
            </h3>
            <p>
              If the user has not paid any fees, Hourlee&rsquo;s maximum
              liability shall be <strong>zero</strong>.
            </p>
            <p>This limitation applies to all causes of action, including:</p>
            <ul>
              <li>
                contract,
                <br />{" "}
              </li>
              <li>
                tort,
                <br />{" "}
              </li>
              <li>
                negligence,
                <br />{" "}
              </li>
              <li>
                strict liability,
                <br />{" "}
              </li>
              <li>
                Statutory claims.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>23.2 Exclusion of Certain Types of Damages</strong>
            </h2>
            <p>
              To the fullest extent permitted by law, Hourlee is{" "}
              <strong>not liable</strong> for:
            </p>
            <ul>
              <li>
                Loss of employment opportunity;
                <br />{" "}
              </li>
              <li>
                loss of salary, benefits, or financial prospects;
                <br />{" "}
              </li>
              <li>
                loss of use, data, or reputation;
                <br />{" "}
              </li>
              <li>
                emotional distress or mental anguish;
                <br />{" "}
              </li>
              <li>
                indirect, incidental, special, punitive, or consequential
                damages;
                <br />{" "}
              </li>
              <li>
                business interruption;
                <br />{" "}
              </li>
              <li>
                data breaches caused by user negligence;
                <br />{" "}
              </li>
              <li>
                actions committed by users outside the Platform;
                <br />{" "}
              </li>
              <li>
                unauthorized use of your login information;
                <br />{" "}
              </li>
              <li>
                fraud, misrepresentation, or misconduct by other users;
                <br />{" "}
              </li>
              <li>
                Damages arising from in-person meetings arranged independently.
                <br />{" "}
              </li>
            </ul>
            <p>
              All risks associated with user interactions remain solely with the
              users.
            </p>
            <h2>
              <strong>23.3 No Liability for User Disputes</strong>
            </h2>
            <p>Hourlee is not responsible for disputes between:</p>
            <ul>
              <li>
                Job Seekers and Employers,
                <br />{" "}
              </li>
              <li>
                Applicants and companies,
                <br />{" "}
              </li>
              <li>
                Agencies and candidates,
                <br />{" "}
              </li>
              <li>
                Any third parties interacting through the Platform.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee is not required to resolve, intervene in, or mediate any
              dispute.
            </p>
            <h2>
              <strong>23.4 No Liability for Data Loss</strong>
            </h2>
            <p>Although Hourlee takes reasonable steps to secure data:</p>
            <p>
              Hourlee does <strong>not</strong> guarantee:
            </p>
            <ul>
              <li>
                That data will never be lost,
                <br />{" "}
              </li>
              <li>
                That backups will always be available,
                <br />{" "}
              </li>
              <li>
                Those stored documents will persist indefinitely.
                <br />{" "}
              </li>
            </ul>
            <p>
              Users should retain their own copies of all important documents.
            </p>
            <h2>
              <strong>23.5 Allocation of Risk</strong>
            </h2>
            <p>You acknowledge that:</p>
            <ul>
              <li>
                The Platform is merely a digital facilitator.
                <br />{" "}
              </li>
              <li>
                Hourlee cannot control user behaviour.
                <br />{" "}
              </li>
              <li>
                Hourlee cannot predict hiring outcomes.
                <br />{" "}
              </li>
              <li>
                Hourlee cannot guarantee the legitimacy of job listings or
                resumes.
                <br />{" "}
              </li>
              <li>
                All risk inherent in interacting, negotiating, hiring, or
                applying rests solely with you.
                <br />{" "}
              </li>
            </ul>
            <p>This Agreement allocates risk accordingly.</p>
            <h3>
              <strong>24. INDEMNIFICATION</strong>
            </h3>
            <h2>
              <strong>24.1 User Indemnification Obligations</strong>
            </h2>
            <p>
              You agree to defend, indemnify, and hold harmless{" "}
              <strong>Hourlee</strong>, its directors, employees, partners,
              licensors, and affiliates from any claims, liabilities, damages,
              losses, or expenses (including reasonable legal fees) arising out
              of:
            </p>
            <ol>
              <li>
                Your use of the Platform;
                <br />{" "}
              </li>
              <li>
                your breach of this Agreement or Privacy Policy;
                <br />{" "}
              </li>
              <li>
                your violation of any law, regulation, or third-party right;
                <br />{" "}
              </li>
              <li>
                your misrepresentations, false statements, or fraudulent
                conduct;
                <br />{" "}
              </li>
              <li>
                any content uploaded by you (resumes, job listings, messages,
                documents);
                <br />{" "}
              </li>
              <li>
                your interactions or disputes with other users;
                <br />{" "}
              </li>
              <li>
                Your conduct during interviews or off-platform engagements.
                <br />{" "}
              </li>
            </ol>
            <h2>
              <strong>24.2 Hourlee&rsquo;s Right to Control Defence</strong>
            </h2>
            <p>
              Hourlee reserves the right to assume exclusive control of any
              matter subject to indemnification.
              <br /> &nbsp;In such cases, you will:
            </p>
            <ul>
              <li>
                cooperate fully,
                <br />{" "}
              </li>
              <li>
                Provide required documents,
                <br />{" "}
              </li>
              <li>
                Not interfere with Hourlee&rsquo;s legal strategy.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>25. WARRANTY DISCLAIMER</strong>
            </h3>
            <p>
              Hourlee expressly disclaims all warranties, express or implied,
              including:
            </p>
            <ul>
              <li>
                merchantability,
                <br />{" "}
              </li>
              <li>
                fitness for a particular purpose,
                <br />{" "}
              </li>
              <li>
                accuracy,
                <br />{" "}
              </li>
              <li>
                reliability,
                <br />{" "}
              </li>
              <li>
                non-infringement,
                <br />{" "}
              </li>
              <li>
                Uninterrupted or error-free functionality.
                <br />{" "}
              </li>
            </ul>
            <p>
              You agree that <strong>no advice or communication</strong> from
              Hourlee creates any warranty not expressly stated in this
              Agreement.
            </p>
            <h3>
              <strong>26. ACCOUNT SUSPENSION AND TERMINATION</strong>
            </h3>
            <h2>
              <strong>
                26.1 Hourlee&rsquo;s Right to Suspend or Terminate
              </strong>
            </h2>
            <p>
              Hourlee reserves the absolute right, at its sole discretion and
              without prior notice, to <strong>suspend</strong>,{" "}
              <strong>restrict</strong>, or <strong>terminate</strong> your:
            </p>
            <ul>
              <li>
                User Account,
                <br />{" "}
              </li>
              <li>
                Access to the Platform,
                <br />{" "}
              </li>
              <li>
                Ability to apply for jobs,
                <br />{" "}
              </li>
              <li>
                Ability to post job listings,
                <br />{" "}
              </li>
              <li>
                Communication functionalities,
                <br />{" "}
              </li>
              <li>
                Uploaded content,
                <br />{" "}
              </li>
              <li>
                Interaction rights.
                <br />{" "}
              </li>
            </ul>
            <p>
              Hourlee may exercise this right for any reason, including but not
              limited to:
            </p>
            <ol>
              <li>
                Violation of this Agreement or the Privacy Policy;
                <br />{" "}
              </li>
              <li>
                violation of applicable laws or regulations;
                <br />{" "}
              </li>
              <li>
                abuse of Platform features;
                <br />{" "}
              </li>
              <li>
                fraudulent or misleading behaviour;
                <br />{" "}
              </li>
              <li>
                impersonation of another individual or entity;
                <br />{" "}
              </li>
              <li>
                posting false, harmful, or illegal job postings/resumes;
                <br />{" "}
              </li>
              <li>
                misuse of other users&rsquo; personal data;
                <br />{" "}
              </li>
              <li>
                harassment, discrimination, or inappropriate conduct;
                <br />{" "}
              </li>
              <li>
                suspicious account activity or potential unauthorized access;
                <br />{" "}
              </li>
              <li>
                non-cooperation with compliance or identity verification
                requests;
                <br />{" "}
              </li>
              <li>
                Repeated user complaints.
                <br />{" "}
              </li>
            </ol>
            <p>
              Hourlee is <strong>not required</strong> to provide justification
              for the termination unless legally required.
            </p>
            <h2>
              <strong>26.2 User-Initiated Account Termination</strong>
            </h2>
            <p>You may request closure of your account at any time by:</p>
            <ul>
              <li>
                Accessing your account settings, or
                <br />{" "}
              </li>
              <li>
                Submit a written request to Hourlee&rsquo;s support team.
                <br />{" "}
              </li>
            </ul>
            <p>Upon receipt, Hourlee will:</p>
            <ul>
              <li>
                Deactivate the account,
                <br />{" "}
              </li>
              <li>
                Remove public visibility of your profile,
                <br />{" "}
              </li>
              <li>
                Restrict future access, and
                <br />{" "}
              </li>
              <li>
                Begin processing your data in accordance with the Privacy
                Policy.
                <br />{" "}
              </li>
            </ul>
            <p>Some information may remain stored for:</p>
            <ul>
              <li>
                legal obligations,
                <br />{" "}
              </li>
              <li>
                fraud prevention,
                <br />{" "}
              </li>
              <li>
                dispute resolution,
                <br />{" "}
              </li>
              <li>
                Legitimate business interests (e.g., security logs).
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>26.3 Temporary Suspension</strong>
            </h2>
            <p>
              Hourlee may temporarily suspend your account for issues,
              including:
            </p>
            <ul>
              <li>
                Suspected fraudulent behaviour,
                <br />{" "}
              </li>
              <li>
                verification pending,
                <br />{" "}
              </li>
              <li>
                Repeated content violations,
                <br />{" "}
              </li>
              <li>
                misuse of communication tools,
                <br />{" "}
              </li>
              <li>
                automated or bot-driven behaviour,
                <br />{" "}
              </li>
              <li>
                System security problems.
                <br />{" "}
              </li>
            </ul>
            <p>Users may be required to complete:</p>
            <ul>
              <li>
                identity verification,
                <br />{" "}
              </li>
              <li>
                documentation submission,
                <br />{" "}
              </li>
              <li>
                Compliance questionnaires.
                <br />{" "}
              </li>
            </ul>
            <p>Hourlee is not obligated to restore access.</p>
            <h2>
              <strong>26.4 Termination of Access for Inactive Accounts</strong>
            </h2>
            <p>
              To maintain platform integrity, Hourlee may terminate accounts
              that remain inactive:
            </p>
            <ul>
              <li>
                Inactive for an extended period,
                <br />{" "}
              </li>
              <li>
                unverified despite requests,
                <br />{" "}
              </li>
              <li>
                Abandoned without login usage.
                <br />{" "}
              </li>
            </ul>
            <p>Users will be given notice when required by law.</p>
            <h3>
              <strong>27. CONSEQUENCES OF TERMINATION</strong>
            </h3>
            <h2>
              <strong>27.1 Immediate Effects</strong>
            </h2>
            <p>Upon termination (by either party), you acknowledge that:</p>
            <ul>
              <li>
                Access to the Platform is permanently revoked.
                <br />{" "}
              </li>
              <li>
                Job application history may no longer be recoverable.
                <br />{" "}
              </li>
              <li>
                Communications with employers may be deleted.
                <br />{" "}
              </li>
              <li>
                Employer listings created by the user may be removed.
                <br />{" "}
              </li>
              <li>
                Active job applications may be cancelled.
                <br />{" "}
              </li>
              <li>
                You have no right to any stored data beyond what is permitted by
                law.
                <br />{" "}
              </li>
              <li>
                Hourlee owes no compensation, refund, or payment for terminated
                services.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>27.2 No Liability for Termination</strong>
            </h2>
            <p>Hourlee shall not be liable to you or any third party for:</p>
            <ul>
              <li>
                Termination of your account,
                <br />{" "}
              </li>
              <li>
                deletion of your data,
                <br />{" "}
              </li>
              <li>
                disruption of your job application process,
                <br />{" "}
              </li>
              <li>
                missed employment opportunities,
                <br />{" "}
              </li>
              <li>
                removal of job listings,
                <br />{" "}
              </li>
              <li>
                Suspension of platform access.
                <br />{" "}
              </li>
            </ul>
            <p>
              All risks arising from termination remain solely with the user.
            </p>
            <h2>
              <strong>27.3 Post-Termination Restrictions</strong>
            </h2>
            <p>Even after termination:</p>
            <ul>
              <li>
                You may not create a new account without explicit permission.
                <br />{" "}
              </li>
              <li>
                You remain responsible for prior conduct.
                <br />{" "}
              </li>
              <li>
                You may not bypass restrictions by using another person&rsquo;s
                account.
                <br />{" "}
              </li>
            </ul>
            <p>Attempting to circumvent the termination may result in:</p>
            <ul>
              <li>
                legal action,
                <br />{" "}
              </li>
              <li>
                reporting to the relevant authorities,
                <br />{" "}
              </li>
              <li>
                Permanent IP-based blocking.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>27.4 No Automatic Data Deletion</strong>
            </h2>
            <p>
              Termination does <em>not</em> automatically delete all data.
              <br /> &nbsp;Data retention periods apply as described in the
              Privacy Policy.
            </p>
            <p>Data may be retained for:</p>
            <ul>
              <li>
                Statutory compliance obligations,
                <br />{" "}
              </li>
              <li>
                preventing fraud,
                <br />{" "}
              </li>
              <li>
                protecting platform integrity,
                <br />{" "}
              </li>
              <li>
                resolving disputes,
                <br />{" "}
              </li>
              <li>
                Archiving transactional information.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>28. SURVIVAL OF TERMS</strong>
            </h3>
            <p>
              The following sections{" "}
              <strong>continue to remain in force indefinitely</strong>, even
              after termination:
            </p>
            <ul>
              <li>
                Intellectual Property
                <br />{" "}
              </li>
              <li>
                User Conduct Obligations
                <br />{" "}
              </li>
              <li>
                Prohibited Activities
                <br />{" "}
              </li>
              <li>
                Disclaimers
                <br />{" "}
              </li>
              <li>
                Limitation of Liability
                <br />{" "}
              </li>
              <li>
                Indemnification
                <br />{" "}
              </li>
              <li>
                Privacy and Data Usage Obligations
                <br />{" "}
              </li>
              <li>
                Governing Law
                <br />{" "}
              </li>
              <li>
                Dispute Resolution
                <br />{" "}
              </li>
              <li>
                Unauthorized Use Provisions
                <br />{" "}
              </li>
              <li>
                Compliance Requirements
                <br />{" "}
              </li>
              <li>
                Interpretation and Severability
                <br />{" "}
              </li>
            </ul>
            <p>
              This ensures Hourlee&rsquo;s rights and legal protections remain
              in effect.
            </p>
            <h3>
              <strong>29. COMPLIANCE WITH LAW AND GOVERNMENT REQUESTS</strong>
            </h3>
            <h2>
              <strong>29.1 Cooperation with Authorities</strong>
            </h2>
            <p>Hourlee reserves the right to:</p>
            <ul>
              <li>
                Cooperate fully with law enforcement,
                <br />{" "}
              </li>
              <li>
                Provide user logs where legally required,
                <br />{" "}
              </li>
              <li>
                Comply with court orders, summons, warrants, or statutory
                requests,
                <br />{" "}
              </li>
              <li>
                Investigate violations related to employment fraud, identity
                fraud, harassment, or illegal job activity.
                <br />{" "}
              </li>
            </ul>
            <p>You agree that Hourlee may disclose:</p>
            <ul>
              <li>
                account information,
                <br />{" "}
              </li>
              <li>
                IP address logs,
                <br />{" "}
              </li>
              <li>
                uploaded content,
                <br />{" "}
              </li>
              <li>
                communication records,
                <br />{" "}
              </li>
            </ul>
            <p>If required by applicable law.</p>
            <h2>
              <strong>29.2 Compliance Monitoring</strong>
            </h2>
            <p>
              To maintain the safety and integrity of the Platform, Hourlee may:
            </p>
            <ul>
              <li>
                Monitor user behaviour,
                <br />{" "}
              </li>
              <li>
                Screen uploads for violations,
                <br />{" "}
              </li>
              <li>
                audit job listings and resumes,
                <br />{" "}
              </li>
              <li>
                Employ automated detection for fraudulent activity,
                <br />{" "}
              </li>
              <li>
                Implement identity checks as needed.
                <br />{" "}
              </li>
            </ul>
            <p>Users must comply with any such requests.</p>
            <h3>
              <strong>30. GOVERNING LAW</strong>
            </h3>
            <p>
              This Agreement shall be governed by and construed exclusively in
              accordance with the <strong>laws of India</strong>, without regard
              to any conflict-of-law principles.
            </p>
            <p>
              All Users acknowledge and agree that the Hourlee Platform operates
              within the jurisdiction of India, and all rights, remedies, and
              obligations contained herein are enforceable under Indian law.
            </p>
            <h3>
              <strong>31. JURISDICTION</strong>
            </h3>
            <p>You agree that:</p>
            <ul>
              <li>
                Any disputes, claims, or legal proceedings arising out of or
                related to the use of the Platform,
                <br />{" "}
              </li>
              <li>
                any breach of this Agreement, and
                <br />{" "}
              </li>
              <li>
                any contractual or non-contractual obligations related to
                Hourlee,
                <br />{" "}
              </li>
            </ul>
            <p>
              Shall fall within the{" "}
              <strong>
                exclusive jurisdiction of the courts located in India.
              </strong>
            </p>
            <p>You expressly waive:</p>
            <ul>
              <li>
                Objections based on improper venue,
                <br />{" "}
              </li>
              <li>
                objections based on lack of personal jurisdiction,
                <br />{" "}
              </li>
              <li>
                Objections based on forum non conveniens.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>32. DISPUTE RESOLUTION</strong>
            </h3>
            <h2>
              <strong>32.1 Mandatory Informal Resolution</strong>
            </h2>
            <p>Before initiating any formal proceedings, Users must:</p>
            <ol>
              <li>
                Send a written notice describing the dispute in detail.
                <br />{" "}
              </li>
              <li>
                Allow Hourlee <strong>at least 30 days</strong> to attempt
                informal resolution.
                <br />{" "}
              </li>
            </ol>
            <p>
              Notices must be sent to Hourlee using the official contact
              information stated in Section 31.
            </p>
            <h2>
              <strong>32.2 Arbitration Clause</strong>
            </h2>
            <h2>
              If Hourlee elects to include arbitration in the final legally
              binding version, the following applies:
            </h2>
            <ul>
              <li>
                Disputes shall be resolved through binding arbitration under the{" "}
                <strong>Arbitration and Conciliation Act, 1996</strong>.<br />{" "}
              </li>
              <li>
                The arbitration seat shall be <strong>Delhi, India</strong>.
                <br />{" "}
              </li>
              <li>
                Proceedings shall be conducted in English.
                <br />{" "}
              </li>
              <li>
                Each party shall bear its own costs unless the arbitrator
                decides otherwise.
                <br />{" "}
              </li>
            </ul>
            <h2>
              <strong>32.3 Exclusions from Arbitration</strong>
            </h2>
            <p>
              The following disputes may be brought directly before a court:
            </p>
            <ul>
              <li>
                Intellectual property rights enforcement,
                <br />{" "}
              </li>
              <li>
                unauthorized access or hacking incidents,
                <br />{" "}
              </li>
              <li>
                fraudulent or illegal use of the Platform,
                <br />{" "}
              </li>
              <li>
                Violations that threaten Hourlee&rsquo;s platform integrity.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>33. NOTICES</strong>
            </h3>
            <p>All official notices between Users and Hourlee must be:</p>
            <ul>
              <li>
                in writing,
                <br />{" "}
              </li>
              <li>
                sent to the designated Hourlee contact email/address, and
                <br />{" "}
              </li>
              <li>
                Deemed effective upon receipt.
                <br />{" "}
              </li>
            </ul>
            <p>Examples include:</p>
            <ul>
              <li>
                Account termination requests,
                <br />{" "}
              </li>
              <li>
                compliance documentation requests,
                <br />{" "}
              </li>
              <li>
                legal notices,
                <br />{" "}
              </li>
              <li>
                dispute notices,
                <br />{" "}
              </li>
              <li>
                Privacy requests under applicable law.
                <br />{" "}
              </li>
            </ul>
            <p>Hourlee may provide notices via:</p>
            <ul>
              <li>
                email,
                <br />{" "}
              </li>
              <li>
                in-platform notifications,
                <br />{" "}
              </li>
              <li>
                updated policy versions posted publicly,
                <br />{" "}
              </li>
              <li>
                SMS (if applicable).
                <br />{" "}
              </li>
            </ul>
            <p>You are responsible for maintaining a valid email address.</p>
            <h3>
              <strong>34. CHANGES TO THIS AGREEMENT</strong>
            </h3>
            <p>Hourlee reserves the unconditional right to:</p>
            <ul>
              <li>
                update,
                <br />{" "}
              </li>
              <li>
                modify,
                <br />{" "}
              </li>
              <li>
                replace,
                <br />{" "}
              </li>
              <li>
                amend, or
                <br />{" "}
              </li>
              <li>
                revise
                <br />{" "}
              </li>
            </ul>
            <p>Any portion of this User Service Agreement at any time.</p>
            <p>
              Updated versions will be posted on{" "}
              <a href="https://hourlee.in/">
                <strong>https://hourlee.in/</strong>
              </a>{" "}
              with the &ldquo;Last Updated&rdquo; date.
            </p>
            <p>
              Continued use of the Platform constitutes{" "}
              <strong>full acceptance</strong> of the revised terms.
            </p>
            <h3>
              <strong>35. ASSIGNMENT</strong>
            </h3>
            <p>
              You may <strong>not</strong> assign, sublicense, transfer, or
              delegate:
            </p>
            <ul>
              <li>
                your rights,
                <br />{" "}
              </li>
              <li>
                your obligations,
                <br />{" "}
              </li>
              <li>
                your account,
                <br />{" "}
              </li>
              <li>
                any claims arising under this Agreement,
                <br />{" "}
              </li>
            </ul>
            <p>
              To any third party without Hourlee&rsquo;s express written
              consent.
            </p>
            <p>
              Hourlee may freely assign its rights and obligations, including
              during:
            </p>
            <ul>
              <li>
                mergers,
                <br />{" "}
              </li>
              <li>
                acquisitions,
                <br />{" "}
              </li>
              <li>
                restructuring,
                <br />{" "}
              </li>
              <li>
                Transfer of business operations.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>36. SEVERABILITY</strong>
            </h3>
            <p>If any provision of this Agreement is found to be:</p>
            <ul>
              <li>
                invalid,
                <br />{" "}
              </li>
              <li>
                unlawful,
                <br />{" "}
              </li>
              <li>
                void, or
                <br />{" "}
              </li>
              <li>
                unenforceable,
                <br />{" "}
              </li>
            </ul>
            <p>
              That provision shall be severed without affecting the validity of
              the remaining provisions.
            </p>
            <p>
              The remaining provisions shall continue in full force and effect.
            </p>
            <h3>
              <strong>37. NO WAIVER</strong>
            </h3>
            <p>
              Failure by Hourlee to enforce any provision of this Agreement does{" "}
              <strong>not</strong> constitute:
            </p>
            <ul>
              <li>
                A waiver of rights,
                <br />{" "}
              </li>
              <li>
                a waiver of enforcement, or
                <br />{" "}
              </li>
              <li>
                Permission for future violations.
                <br />{" "}
              </li>
            </ul>
            <p>
              Waivers must be explicitly stated in <strong>written form</strong>
              .
            </p>
            <h3>
              <strong>38. RELATIONSHIP OF PARTIES</strong>
            </h3>
            <p>Nothing in this Agreement creates:</p>
            <ul>
              <li>
                a partnership,
                <br />{" "}
              </li>
              <li>
                joint venture,
                <br />{" "}
              </li>
              <li>
                employer-employee relationship,
                <br />{" "}
              </li>
              <li>
                principal-agent relationship, or
                <br />{" "}
              </li>
              <li>
                franchise arrangement
                <br />{" "}
              </li>
            </ul>
            <p>Between Hourlee and any User.</p>
            <p>
              Users acknowledge that they act <strong>independently</strong>,
              and Hourlee does not guarantee employment.
            </p>
            <h3>
              <strong>39. ENTIRE AGREEMENT</strong>
            </h3>
            <p>
              This Agreement constitutes the <strong>entire agreement</strong>{" "}
              between:
            </p>
            <ul>
              <li>
                Hourlee, and
                <br />{" "}
              </li>
              <li>
                All Users of the Platform (Clients and Service Providers).
                <br />{" "}
              </li>
            </ul>
            <p>It supersedes all:</p>
            <ul>
              <li>
                prior agreements,
                <br />{" "}
              </li>
              <li>
                representations,
                <br />{" "}
              </li>
              <li>
                verbal or written communications,
                <br />{" "}
              </li>
              <li>
                Informal understandings.
                <br />{" "}
              </li>
            </ul>
            <p>
              No external statements modify this Agreement unless formally
              issued by Hourlee.
            </p>
            <h3>
              <strong>40. CONTACT INFORMATION</strong>
            </h3>
            <p>
              For notices, complaints, legal requests, or user support, contact
              Hourlee at:
            </p>
            <p>
              <strong>
                Hourlee
                <br />{" "}
              </strong>
              Corporate Address - 52 / 1 , Park Road , Dehradun 248001
            </p>
            <p>
              Email Address - Contact@hourlee.in
              <br /> Phone Number - 9811999641
            </p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default UserService;
